/**
 * UI components barrel export
 * @module shared/components/ui
 */

export { GlobalSpinner } from './GlobalSpinner';
